import apiClient from "@/api/client"
import type { ApiResponse } from "@/types/api"
import type {
  Course,
  CourseDocument,
  CourseFilters,
  CreateCourseFormData,
  UpdateCourseFormData,
} from "../types"

export const coursesApi = {
  fetchAll: (filters: CourseFilters) =>
    apiClient.get<ApiResponse<Course[]>>("/courses", { params: filters }),

  fetchOne: (id: string) =>
    apiClient.get<ApiResponse<Course>>(`/courses/${id}`),

  create: (data: CreateCourseFormData) =>
    apiClient.post<ApiResponse<Course>>("/courses", data),

  update: (id: string, data: UpdateCourseFormData) =>
    apiClient.put<ApiResponse<Course>>(`/courses/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<void>(`/courses/${id}`),

  publish: (id: string) =>
    apiClient.post<ApiResponse<Course>>(`/courses/${id}/publish`),

  archive: (id: string) =>
    apiClient.post<ApiResponse<Course>>(`/courses/${id}/archive`),

  uploadDocument: (
    courseId: string,
    file: File,
    onProgress?: (percent: number) => void
  ) => {
    const form = new FormData()
    form.append("file", file)
    return apiClient.post<ApiResponse<CourseDocument>>(
      `/courses/${courseId}/documents`,
      form,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: onProgress
          ? (evt) => {
              if (evt.total) {
                onProgress(Math.round((evt.loaded / evt.total) * 100))
              }
            }
          : undefined,
      }
    )
  },

  deleteDocument: (courseId: string, docId: string) =>
    apiClient.delete<void>(`/courses/${courseId}/documents/${docId}`),

  getDocumentStatus: (courseId: string, docId: string) =>
    apiClient.get<ApiResponse<CourseDocument>>(
      `/courses/${courseId}/documents/${docId}/status`
    ),
}
